import React from "react";
const PlusIcon = _ref => {
  let {
    isActive
  } = _ref;
  return /*#__PURE__*/React.createElement("div", {
    className: "item-cell expand-grid"
  }, isActive ? /*#__PURE__*/React.createElement("i", {
    className: "fbr-icon-plus is-active"
  }) : /*#__PURE__*/React.createElement("i", {
    className: "fbr-icon-plus"
  }));
};
export default PlusIcon;